"use strict";

exports.__esModule = true;
exports.FontLineHeightXxlBp2 = exports.FontLineHeightXlBp2 = exports.FontLineHeightLgBp2 = exports.FontLineHeightXxl = exports.FontLineHeightXl = exports.FontLineHeightLg = exports.FontLineHeightMd = exports.FontLineHeightSm = exports.FontSizeXxlBp2 = exports.FontSizeXlBp2 = exports.FontSizeLgBp2 = exports.FontSizeXxl = exports.FontSizeXl = exports.FontSizeLg = exports.FontSizeMd = exports.FontSizeSm = exports.FontStack = exports.ColorBlurpleOpac50 = exports.ColorBlurple05 = exports.ColorBlurple90 = exports.ColorBlurple80 = exports.ColorBlurple70 = exports.ColorBlurple60 = exports.ColorBlurple50 = exports.ColorBlurple40 = exports.ColorBlurple30 = exports.ColorBlurple20 = exports.ColorBlurple10 = exports.ColorIce05 = exports.ColorIce90 = exports.ColorIce80 = exports.ColorIce70 = exports.ColorIce60 = exports.ColorIce50 = exports.ColorIce40 = exports.ColorIce30 = exports.ColorIce20 = exports.ColorIce10 = exports.ColorEmerald05 = exports.ColorEmerald90 = exports.ColorEmerald80 = exports.ColorEmerald70 = exports.ColorEmerald60 = exports.ColorEmerald50 = exports.ColorEmerald40 = exports.ColorEmerald30 = exports.ColorEmerald20 = exports.ColorEmerald10 = exports.ColorSunshine05 = exports.ColorSunshine90 = exports.ColorSunshine80 = exports.ColorSunshine70 = exports.ColorSunshine60 = exports.ColorSunshine50 = exports.ColorSunshine40 = exports.ColorSunshine30 = exports.ColorSunshine20 = exports.ColorSunshine10 = exports.ColorTangerine05 = exports.ColorTangerine90 = exports.ColorTangerine80 = exports.ColorTangerine70 = exports.ColorTangerine60 = exports.ColorTangerine50 = exports.ColorTangerine40 = exports.ColorTangerine30 = exports.ColorTangerine20 = exports.ColorTangerine10 = exports.ColorLava05 = exports.ColorLava90 = exports.ColorLava80 = exports.ColorLava70 = exports.ColorLava60 = exports.ColorLava50 = exports.ColorLava40 = exports.ColorLava30 = exports.ColorLava20 = exports.ColorLava10 = exports.ColorRose05 = exports.ColorRose90 = exports.ColorRose80 = exports.ColorRose70 = exports.ColorRose60 = exports.ColorRose50 = exports.ColorRose40 = exports.ColorRose30 = exports.ColorRose20 = exports.ColorRose10 = exports.ColorBrandDowjones = exports.ColorBlack = exports.ColorInk = exports.ColorAsphalt = exports.ColorGray = exports.ColorStainlessOpac20 = exports.ColorStainless = exports.ColorCool = exports.ColorWhite = exports.BorderWidth = exports.BorderColor = exports.BorderRadius = void 0;
exports.ZindexMinor = exports.ZindexMid = exports.ZindexMajor = exports.ZindexTop = exports.SpacerXl = exports.SpacerLg = exports.SpacerMlg = exports.SpacerMd = exports.SpacerSmd = exports.SpacerSm = exports.SpacerXs = exports.ModuleHeaderbarBp2 = exports.ModuleHeaderbarBp1 = exports.ModuleSidebarCollapsedWidth = exports.ModuleSidebarOpenWidth = exports.ModuleButtonHeight = exports.GridPageFullwidth = exports.GridMarginOuter = exports.GridContainerLg = exports.GridContainerMd = exports.GridContainerSm = exports.GridGutterCompensation = exports.GridGutterHalf = exports.GridGutterWidth = exports.GridBreakpointLgMin = exports.GridBreakpointMdMax = exports.GridBreakpointMdMin = exports.GridBreakpointSmMax = exports.GridBreakpointSmMin = exports.GridBreakpointXsMax = exports.FontWeightBlack = exports.FontWeightBold = exports.FontWeightMed = exports.FontWeightReg = void 0;

/**
 * Do not edit directly
 * Generated on Mon, 01 Mar 2021 16:32:53 GMT
 */
var BorderRadius = 2;
exports.BorderRadius = BorderRadius;
var BorderColor = "#dfe6e9";
exports.BorderColor = BorderColor;
var BorderWidth = 1;
exports.BorderWidth = BorderWidth;
var ColorWhite = "#ffffff";
exports.ColorWhite = ColorWhite;
var ColorCool = "#f5f7f8";
exports.ColorCool = ColorCool;
var ColorStainless = "#dfe6e9";
exports.ColorStainless = ColorStainless;
var ColorStainlessOpac20 = "#dfe6e9";
exports.ColorStainlessOpac20 = ColorStainlessOpac20;
var ColorGray = "#b2bec3";
exports.ColorGray = ColorGray;
var ColorAsphalt = "#636e72";
exports.ColorAsphalt = ColorAsphalt;
var ColorInk = "#2d3436";
exports.ColorInk = ColorInk;
var ColorBlack = "#000000";
exports.ColorBlack = ColorBlack;
var ColorBrandDowjones = "#02a3d5";
exports.ColorBrandDowjones = ColorBrandDowjones;
var ColorRose10 = "#ffdde9";
exports.ColorRose10 = ColorRose10;
var ColorRose20 = "#ffbbd3";
exports.ColorRose20 = ColorRose20;
var ColorRose30 = "#ff99be";
exports.ColorRose30 = ColorRose30;
var ColorRose40 = "#ff77a8";
exports.ColorRose40 = ColorRose40;
var ColorRose50 = "#ff5592";
exports.ColorRose50 = ColorRose50;
var ColorRose60 = "#cc4475";
exports.ColorRose60 = ColorRose60;
var ColorRose70 = "#993358";
exports.ColorRose70 = ColorRose70;
var ColorRose80 = "#66223a";
exports.ColorRose80 = ColorRose80;
var ColorRose90 = "#33111d";
exports.ColorRose90 = ColorRose90;
var ColorRose05 = "#ffeef4";
exports.ColorRose05 = ColorRose05;
var ColorLava10 = "#fad9d4";
exports.ColorLava10 = ColorLava10;
var ColorLava20 = "#f4b3a8";
exports.ColorLava20 = ColorLava20;
var ColorLava30 = "#ef8e7d";
exports.ColorLava30 = ColorLava30;
var ColorLava40 = "#e96851";
exports.ColorLava40 = ColorLava40;
var ColorLava50 = "#e44226";
exports.ColorLava50 = ColorLava50;
var ColorLava60 = "#b6351e";
exports.ColorLava60 = ColorLava60;
var ColorLava70 = "#892817";
exports.ColorLava70 = ColorLava70;
var ColorLava80 = "#5b1a0f";
exports.ColorLava80 = ColorLava80;
var ColorLava90 = "#2e0d08";
exports.ColorLava90 = ColorLava90;
var ColorLava05 = "#fcece9";
exports.ColorLava05 = ColorLava05;
var ColorTangerine10 = "#fde9da";
exports.ColorTangerine10 = ColorTangerine10;
var ColorTangerine20 = "#fbd3b6";
exports.ColorTangerine20 = ColorTangerine20;
var ColorTangerine30 = "#fabc91";
exports.ColorTangerine30 = ColorTangerine30;
var ColorTangerine40 = "#f8a66c";
exports.ColorTangerine40 = ColorTangerine40;
var ColorTangerine50 = "#f69047";
exports.ColorTangerine50 = ColorTangerine50;
var ColorTangerine60 = "#c57339";
exports.ColorTangerine60 = ColorTangerine60;
var ColorTangerine70 = "#764522";
exports.ColorTangerine70 = ColorTangerine70;
var ColorTangerine80 = "#623a1d";
exports.ColorTangerine80 = ColorTangerine80;
var ColorTangerine90 = "#311d0e";
exports.ColorTangerine90 = ColorTangerine90;
var ColorTangerine05 = "#fef3ec";
exports.ColorTangerine05 = ColorTangerine05;
var ColorSunshine10 = "#fef3d9";
exports.ColorSunshine10 = ColorSunshine10;
var ColorSunshine20 = "#fce7b4";
exports.ColorSunshine20 = ColorSunshine20;
var ColorSunshine30 = "#fbdc8e";
exports.ColorSunshine30 = ColorSunshine30;
var ColorSunshine40 = "#f9d069";
exports.ColorSunshine40 = ColorSunshine40;
var ColorSunshine50 = "#f8c443";
exports.ColorSunshine50 = ColorSunshine50;
var ColorSunshine60 = "#c69d36";
exports.ColorSunshine60 = ColorSunshine60;
var ColorSunshine70 = "#957628";
exports.ColorSunshine70 = ColorSunshine70;
var ColorSunshine80 = "#634e1b";
exports.ColorSunshine80 = ColorSunshine80;
var ColorSunshine90 = "#32270d";
exports.ColorSunshine90 = ColorSunshine90;
var ColorSunshine05 = "#fef9ec";
exports.ColorSunshine05 = ColorSunshine05;
var ColorEmerald10 = "#dcf5da";
exports.ColorEmerald10 = ColorEmerald10;
var ColorEmerald20 = "#b9ecb4";
exports.ColorEmerald20 = ColorEmerald20;
var ColorEmerald30 = "#97e28f";
exports.ColorEmerald30 = ColorEmerald30;
var ColorEmerald40 = "#74d969";
exports.ColorEmerald40 = ColorEmerald40;
var ColorEmerald50 = "#51cf44";
exports.ColorEmerald50 = ColorEmerald50;
var ColorEmerald60 = "#41a636";
exports.ColorEmerald60 = ColorEmerald60;
var ColorEmerald70 = "#317c29";
exports.ColorEmerald70 = ColorEmerald70;
var ColorEmerald80 = "#20531b";
exports.ColorEmerald80 = ColorEmerald80;
var ColorEmerald90 = "#10290e";
exports.ColorEmerald90 = ColorEmerald90;
var ColorEmerald05 = "#edfaec";
exports.ColorEmerald05 = ColorEmerald05;
var ColorIce10 = "#d9f6ff";
exports.ColorIce10 = ColorIce10;
var ColorIce20 = "#b3ecff";
exports.ColorIce20 = ColorIce20;
var ColorIce30 = "#8de3ff";
exports.ColorIce30 = ColorIce30;
var ColorIce40 = "#66daff";
exports.ColorIce40 = ColorIce40;
var ColorIce50 = "#40d0ff";
exports.ColorIce50 = ColorIce50;
var ColorIce60 = "#33a7cc";
exports.ColorIce60 = ColorIce60;
var ColorIce70 = "#277d99";
exports.ColorIce70 = ColorIce70;
var ColorIce80 = "#1a5366";
exports.ColorIce80 = ColorIce80;
var ColorIce90 = "#0d2a33";
exports.ColorIce90 = ColorIce90;
var ColorIce05 = "#ebfaff";
exports.ColorIce05 = ColorIce05;
var ColorBlurple10 = "#ddddf7";
exports.ColorBlurple10 = ColorBlurple10;
var ColorBlurple20 = "#bcbbf0";
exports.ColorBlurple20 = ColorBlurple20;
var ColorBlurple30 = "#9a99e8";
exports.ColorBlurple30 = ColorBlurple30;
var ColorBlurple40 = "#7977e1";
exports.ColorBlurple40 = ColorBlurple40;
var ColorBlurple50 = "#5755d9";
exports.ColorBlurple50 = ColorBlurple50;
var ColorBlurple60 = "#4644ae";
exports.ColorBlurple60 = ColorBlurple60;
var ColorBlurple70 = "#343382";
exports.ColorBlurple70 = ColorBlurple70;
var ColorBlurple80 = "#232257";
exports.ColorBlurple80 = ColorBlurple80;
var ColorBlurple90 = "#11112b";
exports.ColorBlurple90 = ColorBlurple90;
var ColorBlurple05 = "#eeeefb";
exports.ColorBlurple05 = ColorBlurple05;
var ColorBlurpleOpac50 = "#5755d9";
exports.ColorBlurpleOpac50 = ColorBlurpleOpac50;
var FontStack = "'Inter UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
exports.FontStack = FontStack;
var FontSizeSm = "0.8125rem";
exports.FontSizeSm = FontSizeSm;
var FontSizeMd = "1rem";
exports.FontSizeMd = FontSizeMd;
var FontSizeLg = "1.125rem";
exports.FontSizeLg = FontSizeLg;
var FontSizeXl = "1.3125rem";
exports.FontSizeXl = FontSizeXl;
var FontSizeXxl = "1.75rem";
exports.FontSizeXxl = FontSizeXxl;
var FontSizeLgBp2 = "1.3125rem";
exports.FontSizeLgBp2 = FontSizeLgBp2;
var FontSizeXlBp2 = "1.75rem";
exports.FontSizeXlBp2 = FontSizeXlBp2;
var FontSizeXxlBp2 = "2.375rem";
exports.FontSizeXxlBp2 = FontSizeXxlBp2;
var FontLineHeightSm = "1rem";
exports.FontLineHeightSm = FontLineHeightSm;
var FontLineHeightMd = "1.5rem";
exports.FontLineHeightMd = FontLineHeightMd;
var FontLineHeightLg = "1.625rem";
exports.FontLineHeightLg = FontLineHeightLg;
var FontLineHeightXl = "1.875rem";
exports.FontLineHeightXl = FontLineHeightXl;
var FontLineHeightXxl = "2.5625rem";
exports.FontLineHeightXxl = FontLineHeightXxl;
var FontLineHeightLgBp2 = "1.875rem";
exports.FontLineHeightLgBp2 = FontLineHeightLgBp2;
var FontLineHeightXlBp2 = "2.5625rem";
exports.FontLineHeightXlBp2 = FontLineHeightXlBp2;
var FontLineHeightXxlBp2 = "3.4375rem";
exports.FontLineHeightXxlBp2 = FontLineHeightXxlBp2;
var FontWeightReg = 400;
exports.FontWeightReg = FontWeightReg;
var FontWeightMed = 500;
exports.FontWeightMed = FontWeightMed;
var FontWeightBold = 700;
exports.FontWeightBold = FontWeightBold;
var FontWeightBlack = 900;
exports.FontWeightBlack = FontWeightBlack;
var GridBreakpointXsMax = "47.999rem";
exports.GridBreakpointXsMax = GridBreakpointXsMax;
var GridBreakpointSmMin = "48rem";
exports.GridBreakpointSmMin = GridBreakpointSmMin;
var GridBreakpointSmMax = "63.999rem";
exports.GridBreakpointSmMax = GridBreakpointSmMax;
var GridBreakpointMdMin = "64rem";
exports.GridBreakpointMdMin = GridBreakpointMdMin;
var GridBreakpointMdMax = "74.999rem";
exports.GridBreakpointMdMax = GridBreakpointMdMax;
var GridBreakpointLgMin = "75rem";
exports.GridBreakpointLgMin = GridBreakpointLgMin;
var GridGutterWidth = "1rem";
exports.GridGutterWidth = GridGutterWidth;
var GridGutterHalf = "0.5rem";
exports.GridGutterHalf = GridGutterHalf;
var GridGutterCompensation = "-0.5rem";
exports.GridGutterCompensation = GridGutterCompensation;
var GridContainerSm = "49rem";
exports.GridContainerSm = GridContainerSm;
var GridContainerMd = "65rem";
exports.GridContainerMd = GridContainerMd;
var GridContainerLg = "76rem";
exports.GridContainerLg = GridContainerLg;
var GridMarginOuter = "0rem";
exports.GridMarginOuter = GridMarginOuter;
var GridPageFullwidth = "75rem";
exports.GridPageFullwidth = GridPageFullwidth;
var ModuleButtonHeight = 40;
exports.ModuleButtonHeight = ModuleButtonHeight;
var ModuleSidebarOpenWidth = 260;
exports.ModuleSidebarOpenWidth = ModuleSidebarOpenWidth;
var ModuleSidebarCollapsedWidth = 32;
exports.ModuleSidebarCollapsedWidth = ModuleSidebarCollapsedWidth;
var ModuleHeaderbarBp1 = 60;
exports.ModuleHeaderbarBp1 = ModuleHeaderbarBp1;
var ModuleHeaderbarBp2 = 48;
exports.ModuleHeaderbarBp2 = ModuleHeaderbarBp2;
var SpacerXs = 4;
exports.SpacerXs = SpacerXs;
var SpacerSm = 8;
exports.SpacerSm = SpacerSm;
var SpacerSmd = 12;
exports.SpacerSmd = SpacerSmd;
var SpacerMd = 16;
exports.SpacerMd = SpacerMd;
var SpacerMlg = 24;
exports.SpacerMlg = SpacerMlg;
var SpacerLg = 32;
exports.SpacerLg = SpacerLg;
var SpacerXl = 48;
exports.SpacerXl = SpacerXl;
var ZindexTop = 100000000000000000;
exports.ZindexTop = ZindexTop;
var ZindexMajor = 100;
exports.ZindexMajor = ZindexMajor;
var ZindexMid = 2;
exports.ZindexMid = ZindexMid;
var ZindexMinor = 1;
exports.ZindexMinor = ZindexMinor;